import { currentMainState } from '../game-plan.state';

export function filterRows(): void {
    const state = currentMainState();

    state.filteredRows = [...state.rows];

    if (state.keyword?.length > 0) {
        state.filteredRows = state.filteredRows.filter(
            (e) => e.name?.toLowerCase().trim().includes(state.keyword),
        );
    }

    if (state.selectedPersonaFilterOptions?.size > 0) {
        state.filteredRows = state.filteredRows.filter((e) =>
            state.selectedPersonaFilterOptions.has(e.personaType),
        );
    }

    state.personaGroups?.forEach((g) => {
        g.rows = state.filteredRows.filter(
            (e) => e.personaType === g.personaType,
        );
    });

    state.actionLanes?.forEach((l) => {
        l.rows = state.filteredRows.filter(
            (e) =>
                e.groupedAction?.actionType === l.actionType ||
                e.otherGroupedActions?.some(
                    (a) => a.actionType === l.actionType,
                ),
        );
    });
}
